/**
 * Asset — coreBOS `Assets` (43x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr,nis2. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const assetDescriptor = {
    slug: 'cmp_asset',
    kind: 'document',
    label: { singular: 'Asset', plural: 'Asset' },
    table: 'compliance_asset',
    idStrategy: 'sha256',
    fields: [
        { name: 'assetname', type: 'text', label: 'Nome Asset', required: true },
        { name: 'asset_type', type: 'text', label: 'Tipo' },
        { name: 'category', type: 'text', label: 'Categoria' },
        { name: 'risk_evaluation', type: 'text', label: 'Valutazione Rischio' },
        { name: 'asset_status', type: 'text', label: 'Stato' },
        { name: 'location', type: 'text', label: 'Ubicazione' },
        { name: 'physical_measurements', type: 'text', label: 'Physical measurements' },
        { name: 'treated_data', type: 'text', label: 'Dati Trattati' },
        { name: 'storage_tools', type: 'text', label: 'Storage tools' },
        { name: 'hardware_resources', type: 'text', label: 'Hardware resources' },
        { name: 'elaborative_system', type: 'text', label: 'Sistema Elaborativo' },
        { name: 'operating_system', type: 'text', label: 'Sistema Operativo' },
        { name: 'cloudservice', type: 'text', label: 'Cloud Service' },
        { name: 'backup_freq', type: 'text', label: 'Frequenza Backup' },
        { name: 'access_level', type: 'text', label: 'Livello Accesso' },
        { name: 'cryptography', type: 'boolean', label: 'Crittografia' },
        { name: 'antivirus', type: 'boolean', label: 'Antivirus' },
        { name: 'firewall', type: 'boolean', label: 'Firewall' },
        { name: 'license_type', type: 'text', label: 'Tipo Licenza' },
        { name: 'license_expiration', type: 'date', label: 'Scadenza Licenza' },
        { name: 'euro_value', type: 'decimal', label: 'Euro value' },
        { name: 'dateinservice', type: 'date', label: 'Dateinservice' },
        { name: 'datesold', type: 'date', label: 'Datesold' },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'framework_tags', type: 'text', label: 'Framework tags' },
        { name: 'criticality', type: 'text', label: 'Criticality' },
    ],
    relations: [
        { name: 'account', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'product', kind: 'belongsTo', target: 'product' },
        { name: 'supplier', kind: 'belongsTo', target: 'cmp_third_party' },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'LaptopOutlined', navGroup: 'Rischi' },
};
